__turbopack_context__.v({
  "accordionSlideOverwrite": "homepageSummitBanner-module-scss-module__l_gqmG__accordionSlideOverwrite",
  "banner": "homepageSummitBanner-module-scss-module__l_gqmG__banner",
  "copy": "homepageSummitBanner-module-scss-module__l_gqmG__copy",
  "fadeIn": "homepageSummitBanner-module-scss-module__l_gqmG__fadeIn",
  "fadeOut": "homepageSummitBanner-module-scss-module__l_gqmG__fadeOut",
  "link": "homepageSummitBanner-module-scss-module__l_gqmG__link",
  "scaleIn": "homepageSummitBanner-module-scss-module__l_gqmG__scaleIn",
  "scaleOut": "homepageSummitBanner-module-scss-module__l_gqmG__scaleOut",
  "zoomIn": "homepageSummitBanner-module-scss-module__l_gqmG__zoomIn",
  "zoomOut": "homepageSummitBanner-module-scss-module__l_gqmG__zoomOut",
});
